export default function Search() {
	// Find the search trigger element and the mobile search wrapper element
	const searchTrigger = document.querySelector('.js-search-trigger');
	const searchWrapper = document.querySelector('.js-search-wrapper');
	const icon = searchTrigger.querySelector('ion-icon')
	
	if (searchTrigger && searchWrapper) {
		// Add a click event listener to the search trigger
		searchTrigger.addEventListener('click', function() {
			searchWrapper.classList.toggle('active')

			if (searchWrapper.classList.contains('active')) {
				document.querySelector('.js-live-search-input').focus()	
			}
			
			if (icon) {
				if (icon.getAttribute('name') === 'search-sharp') {
					icon.setAttribute('name', 'close-sharp')
				} else {
					icon.setAttribute('name', 'search-sharp')
				}
			}
		});
	}
}